/**
 * Must stay in sync with `pitchFrame.aspectRatio` in MatchHubLineupsPanel.styles.ts (width / height).
 * Used to draw a center circle that looks round after non-uniform SVG stretch.
 */
export const LINEUP_PITCH_FRAME_WIDTH_OVER_HEIGHT = 0.66;

/**
 * Green broadcast-pitch artwork (a real football field reads better than a dark inset).
 * Stripe tints sit over the base; markings are chalk-white.
 */
export const LINEUP_PITCH_GREEN = '#15633A';
export const LINEUP_PITCH_STRIPE_LIGHT = 'rgba(255,255,255,0.05)';
export const LINEUP_PITCH_STRIPE_DARK = 'rgba(0,0,0,0.05)';
export const LINEUP_PITCH_LINE = 'rgba(255,255,255,0.5)';
/** Number of vertical mow stripes drawn across the pitch. */
export const LINEUP_PITCH_STRIPE_COUNT = 8;
